<template>
  <div>
    <Loader :active="loading" mensaje="Obteniendo historial de asistencias" />
    <v-card class="mb-5">
      <v-card-title >
          Asistencias registradas
      </v-card-title>
      <v-list>
        <v-list-item v-for="(asistencia, idx) in historial" :key="idx">
          <v-list-item-content>
            <p>
              Entrada: {{ asistencia.entrada }}
            </p>
            <p>
              Salida: {{ asistencia.salida }}
            </p>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="historial.length < 1">
          No ninguna asistencia registradas
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>
<script>
// Services
import { personal } from '../services/personal'
import { session } from '../services/session'
// Components
import Loader from '../components/Loader'

export default {
  name: 'MisAsistencias',
  components: {
    Loader
  },
  data () {
    return {
      historial: [],
      loading: true
    }
  },
  methods: {
    async getHistorial () {
      try {
        const { idUsuario } = session.getData()
        const { data } = await personal.asistencia(idUsuario)

        this.historial = data
      } catch (err) {
        this.$toasted.show(err.message, {
          position: 'bottom-center',
          type: 'error',
          theme: 'bubble',
          icon: 'close-circle'
        })
      } finally {
        this.loading = false
      }
    }
  },
  mounted () {
    this.getHistorial()
  }
}
</script>
